export const spinnerStyle = `
    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
    .twitter-bs-wizard {
        background: transparent;
    }
    .twitter-bs-wizard-nav .nav-link {
        flex-direction: column;
        align-items: center;
        border-radius: 12px;
        padding: 12px;
        color: #6c757d;
        border: 1px solid transparent;
        display: flex;
        justify-content: center;
        gap: 4px;
    }
    .twitter-bs-wizard-nav .nav-link.active {
        background: #eaf1ff;
        color: #032a80;
        border-color: #bfd3ff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }
    .twitter-bs-wizard-nav .step-number {
        width: 36px;
        height: 36px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: #dfe7fb;
        font-weight: 600;
    }
    .twitter-bs-wizard-tab-content {
        min-height: 360px;
        padding-top: 16px;
    }
    .twitter-bs-wizard-tab-content .tab-pane {
        padding: 0;
    }
    .twitter-bs-wizard .wizard-pager {
        list-style: none;
        display: flex;
        justify-content: space-between;
        padding: 0;
        margin: 24px 0 0;
        background: transparent;
    }
    .twitter-bs-wizard .wizard-pager-link a {
        font-weight: 600;
        color: #0147c8;
    }
    .asset-review-modal .modal-dialog {
        max-width: 1100px;
        width: 100%;
        margin: 1.75rem auto;
    }
    .asset-list-card {
        border: none;
        border-radius: 1rem;
        background: linear-gradient(145deg, #ffffff, #f5f7ff);
        box-shadow: 0 15px 35px rgba(3, 40, 128, 0.1);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .asset-list-card.reviewed {
        border: 1px solid rgba(25, 135, 84, 0.45);
        box-shadow: 0 15px 35px rgba(25, 135, 84, 0.22);
    }
    .asset-list-card.not-reviewed {
        border: 1px solid rgba(220, 53, 69, 0.35);
        box-shadow: 0 15px 35px rgba(220, 53, 69, 0.18);
    }
    .asset-list-card:hover {
        transform: translateY(-6px);
        box-shadow: 0 24px 45px rgba(3, 40, 128, 0.15);
    }
    .asset-list-card .card-body {
        padding: 1.25rem;
        display: flex;
        flex-direction: column;
    }
    .asset-list-card .card-meta {
        font-size: 0.85rem;
        color: #6c757d;
        letter-spacing: 0.04em;
        text-transform: uppercase;
    }
    .asset-list-card .asset-field {
        display: flex;
        justify-content: space-between;
        padding: 0.35rem 0;
        border-bottom: 1px solid rgba(4, 54, 117, 0.08);
    }
    .asset-list-card .asset-field:last-child {
        border-bottom: none;
    }
    .asset-list-card .asset-name {
        font-size: 1.1rem;
        font-weight: 600;
        margin-bottom: 0;
    }
    .asset-card-actions {
        margin-top: auto;
    }
    .asset-review-modal .modal-content {
        min-height: 80vh;
    }
    .asset-review-modal .modal-body {
        padding-bottom: 0;
    }
    .review-overview-grid {
        margin-bottom: 1.25rem;
    }
    .review-group-card {
        background: #fff;
        border: 1px solid #e7e9f0;
        border-radius: 0.75rem;
        box-shadow: 0 12px 30px rgba(3, 40, 128, 0.08);
        height: 100%;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .review-group-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 20px 45px rgba(3, 40, 128, 0.15);
    }
    .review-group-card .group-title {
        font-size: 0.85rem;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }
    .review-group-card .group-row {
        font-size: 0.95rem;
        padding: 0.35rem 0;
        border-bottom: 1px solid #f1f1f5;
    }
    .review-group-card .group-row:last-child {
        border-bottom: none;
    }
    @media (max-width: 991px) {
        .asset-review-modal .modal-dialog {
            max-width: 95%;
        }
        .asset-review-modal .modal-content {
            min-height: auto;
        }
    }
    .category-stats-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        gap: 0.85rem;
    }
    .category-stat-card {
        border: 0;
        border-radius: 14px;
        color: #fff;
        padding: 0.9rem 1rem;
        box-shadow: 0 12px 28px rgba(1, 71, 200, 0.22);
        background: linear-gradient(135deg, #0147c8 0%, #0da5d8 100%);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .category-stat-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 16px 34px rgba(1, 71, 200, 0.28);
    }
    .category-stat-card.active {
        outline: 2px solid rgba(255, 255, 255, 0.8);
        outline-offset: 1px;
    }
    .category-stat-top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 0.55rem;
    }
    .category-stat-title {
        font-size: 0.83rem;
        font-weight: 700;
        letter-spacing: 0.02em;
        line-height: 1.25;
    }
    .category-stat-code {
        font-size: 0.72rem;
        font-weight: 700;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        opacity: 0.95;
        padding: 0.1rem 0.45rem;
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.22);
    }
    .category-stat-numbers {
        display: flex;
        gap: 0.75rem;
        font-size: 0.76rem;
        opacity: 0.95;
    }
    .category-stat-numbers strong {
        display: block;
        font-size: 1.05rem;
        line-height: 1.15;
        color: #fff;
    }
    .review-tables-wide-wrapper {
        width: 100%;
        overflow-x: auto;
    }
    .review-tables-wide {
        width: 100%;
        min-width: 1500px;
        table-layout: auto;
    }
    .review-tables-wide th,
    .review-tables-wide td {
        white-space: nowrap;
        padding: 0.9rem 1rem;
        font-size: 0.95rem;
    }
    .review-tables-wide .btn-group {
        flex-wrap: nowrap;
    }
    .asset-photo-card {
        border: 1px solid #dee2e6;
        border-radius: 0.75rem;
        overflow: hidden;
        background: #fff;
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
        width: 100%;
        height: 100%;
        text-align: left;
        transition: transform 0.18s ease, box-shadow 0.18s ease;
    }
    .asset-photo-card:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 14px 30px rgba(15, 23, 42, 0.14);
    }
    .asset-photo-card:disabled {
        cursor: not-allowed;
        opacity: 0.85;
    }
    .asset-photo-card-media {
        width: 100%;
        height: 220px;
        object-fit: cover;
        background: #f1f5f9;
        display: block;
    }
    .asset-photo-card-body {
        padding: 0.85rem 0.95rem;
        border-top: 1px solid #edf0f2;
    }
    .asset-photo-card-title {
        font-size: 0.95rem;
        font-weight: 700;
        color: #212529;
        margin-bottom: 0.2rem;
    }
    .asset-photo-card-subtitle {
        font-size: 0.78rem;
        color: #6c757d;
        margin-bottom: 0;
    }
    .asset-photo-camera-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 50%;
        background: rgba(1, 71, 200, 0.92);
        color: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 18px rgba(1, 71, 200, 0.35);
        cursor: pointer;
        z-index: 2;
    }
    .asset-photo-camera-btn:hover {
        background: #0147c8;
    }
    .asset-photo-card-wrap {
        position: relative;
    }
    .review-tabs-modern {
        display: inline-flex;
        align-items: center;
        gap: 0.35rem;
        padding: 0.35rem;
        border: 1px solid #dbe4f0;
        border-radius: 999px;
        background: linear-gradient(180deg, #f8fbff 0%, #f1f6ff 100%);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
    }
    .review-tab-btn {
        border: 0;
        border-radius: 999px;
        background: transparent;
        color: #4a5d75;
        padding: 0.58rem 1.1rem;
        font-weight: 700;
        letter-spacing: 0.01em;
        transition: all 0.2s ease;
    }
    .review-tab-btn:hover {
        color: #0147c8;
        background: rgba(1, 71, 200, 0.08);
    }
    .review-tab-btn.active {
        color: #fff;
        background: linear-gradient(135deg, #0147c8 0%, #0da5d8 100%);
        box-shadow: 0 8px 18px rgba(1, 71, 200, 0.32);
    }
    .review-tab-btn.review-tab-btn--danger:hover {
        color: #b42318;
        background: rgba(180, 35, 24, 0.08);
    }
    .review-tab-btn.review-tab-btn--danger.active {
        background: linear-gradient(135deg, #b42318 0%, #ef4444 100%);
        box-shadow: 0 8px 18px rgba(180, 35, 24, 0.28);
    }
    .category-tabs-modern {
        display: flex;
        flex-wrap: wrap;
        gap: 0.7rem;
        justify-content: center;
    }
    .category-tab-btn {
        min-width: 170px;
        border: 1px solid #c9d8ea;
        border-radius: 14px;
        background: #fff;
        color: #0d5f8f;
        padding: 0.82rem 1rem;
        text-align: center;
        box-shadow: 0 6px 18px rgba(1, 71, 200, 0.08);
        transition: all 0.2s ease;
    }
    .category-tab-btn:hover {
        transform: translateY(-1px);
        border-color: #8db7ea;
        box-shadow: 0 12px 24px rgba(1, 71, 200, 0.15);
    }
    .category-tab-btn.active {
        border-color: #00a7a0;
        background: linear-gradient(135deg, #0fb39f 0%, #11a8c6 100%);
        color: #fff;
        box-shadow: 0 14px 30px rgba(16, 167, 160, 0.34);
    }
    .category-tab-btn .category-tab-label {
        display: block;
        font-size: 1.05rem;
        font-weight: 800;
        line-height: 1.2;
    }
    .category-tab-btn .category-tab-code {
        display: block;
        margin-top: 0.2rem;
        font-size: 0.74rem;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        opacity: 0.78;
    }
    .category-tab-btn.active .category-tab-code {
        opacity: 0.95;
    }
    .building-edit-stepper {
        display: flex;
        gap: 0.6rem;
        margin-bottom: 1rem;
        flex-wrap: wrap;
    }
    .building-edit-step {
        border: 1px solid #dbe4f0;
        border-radius: 999px;
        padding: 0.4rem 0.8rem;
        font-size: 0.82rem;
        font-weight: 700;
        color: #5b6782;
        background: #f6f9ff;
    }
    .building-edit-step.active {
        color: #fff;
        border-color: transparent;
        background: linear-gradient(135deg, #0147c8 0%, #0da5d8 100%);
        box-shadow: 0 10px 20px rgba(1, 71, 200, 0.25);
    }
    .building-summary-card {
        border: 1px solid #e4e8f0;
        border-radius: 12px;
        background: #f8fbff;
        padding: 0.9rem 1rem;
        margin-bottom: 1rem;
    }
    .building-summary-card .title {
        font-size: 0.8rem;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }
    .building-summary-card .value {
        font-size: 1.2rem;
        font-weight: 700;
        color: #0d2f69;
    }
    .building-slot-card {
        border: 1px solid #dfe6f2;
        border-radius: 14px;
        background: #fff;
        box-shadow: 0 10px 24px rgba(1, 23, 70, 0.08);
        padding: 1rem;
    }
    .building-list-card {
        border: 1px solid #dfe6f2;
        border-radius: 8px;
        background: #fff;
        padding: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        box-shadow: 0 8px 18px rgba(1, 23, 70, 0.06);
    }
    .building-list-card-main {
        min-width: 0;
        flex: 1 1 auto;
    }
    .building-list-card-title {
        font-size: 0.98rem;
        font-weight: 800;
        color: #172b4d;
        margin-bottom: 0.35rem;
    }
    .building-list-card-meta {
        display: flex;
        flex-wrap: wrap;
        gap: 0.45rem;
    }
    .building-list-badge {
        border: 1px solid #dbe4f0;
        border-radius: 999px;
        background: #f6f9ff;
        color: #4a5d75;
        padding: 0.22rem 0.55rem;
        font-size: 0.74rem;
        font-weight: 700;
        white-space: nowrap;
    }
    .building-list-badge.primary {
        border-color: rgba(1, 71, 200, 0.18);
        background: rgba(1, 71, 200, 0.08);
        color: #0147c8;
    }
    .building-list-badge.warning {
        border-color: rgba(245, 158, 11, 0.25);
        background: rgba(245, 158, 11, 0.12);
        color: #945a00;
    }
    .building-slot-title {
        font-size: 0.9rem;
        font-weight: 800;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #10439f;
    }
    .use-status-group {
        display: flex;
        gap: 0.55rem;
        flex-wrap: wrap;
    }
    .use-status-chip {
        border: 1px solid #c9d5ea;
        border-radius: 999px;
        background: #f5f8ff;
        color: #2d4b84;
        padding: 0.35rem 0.8rem;
        font-size: 0.78rem;
        font-weight: 700;
        cursor: pointer;
    }
    .use-status-chip.active {
        color: #fff;
        border-color: transparent;
        background: linear-gradient(135deg, #0147c8 0%, #0da5d8 100%);
    }
    @media (max-width: 768px) {
        .review-tabs-modern {
            width: 100%;
            justify-content: center;
        }
        .review-tab-btn {
            flex: 1 1 auto;
            padding: 0.55rem 0.85rem;
        }
        .category-tabs-modern {
            gap: 0.55rem;
        }
        .category-tab-btn {
            min-width: calc(50% - 0.55rem);
            padding: 0.72rem 0.8rem;
        }
        .building-list-card {
            align-items: stretch;
            flex-direction: column;
        }
    }
`;
